import { useRegisterSW } from 'virtual:pwa-register/react'
import ServiceWorkerUpdateTip from './ServiceWorkerUpdateTip'

export default function ServiceWorkerManager() {
	const {
		needRefresh: [needRefresh],
		updateServiceWorker,
	} = useRegisterSW({
		onRegisteredSW(swUrl, r) {
			console.log('Service Worker registered:', swUrl)
		},
		onRegisterError(error) {
			console.error('Service Worker registration error:', error)
		},
	})

	return (
		<ServiceWorkerUpdateTip
			show={needRefresh}
			onClick={() => {
				// 用户点击时更新 Service Worker 并刷新页面
				updateServiceWorker(true).then(() => {
					window.location.reload()
				})
			}}
		/>
	)
}
